<script setup lang="ts">
import LGHomePageHero from "~/components/home-page/LGHomePageHero.vue";

const { t } = useI18n()

const title = t('home.seo.title')
const description = t('home.seo.description')

useSeoMeta({
    title,
    description,
    robots: 'index,follow',
})

</script>

<template>
    <div class="bg-[#FEFCF9]">
        <LGHomePageHero/>
        <LazyHomePageLGHomePageText/>
        <LazyHomePageLGHomePageReviews/>
        <LazyHomePageLGHomePageShop/>
        <LazyHomePageLGHomePageHowTo/>
        <LazyHomePageLGHomePageOurStory/>
    </div>
</template>

<style scoped>

</style>
